export enum UserIntent {
  SaveAsDraft = 'save-as-draft',
  ScheduleAutoPost = 'schedule-autopost',
  ScheduleReminder = 'schedule-reminder',
  PostNow = 'post-now',
  PostNowWithoutConfirmation = 'post-now-without-confirmation',
  ChangeDate = 'change-date',
  MarkAsPosted = 'mark-as-posted',
  Export = 'export',
  CopyDocContent = 'copy-doc-content',
  RemoveReminder = 'remove-reminder',
  EditContent = 'edit-content',
  MarkAsNotPosted = 'mark-as-not-posted',
  Unschedule = 'unschedule',
}
